import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useScrollToAnchor } from './hooks/useScrollToAnchor';
import { HeroSection } from './components/sections/home/HeroSection';
import AboutSection from './components/sections/home/AboutSection';
import { VenturesSection } from './components/sections/home/VenturesSection';
import { FoundersSection } from './components/sections/home/FoundersSection';
import ContactSection from './components/sections/contact/ContactSection';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import { PersonalTouchSection } from './components/sections/home/PersonalTouchSection';
import { sectionVariants, itemVariants } from './animations/variants';

function App() {
  useScrollToAnchor();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  const menuPortalRoot = document.getElementById('menu-portal');

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    } else {
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '';
    }
    return () => {
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '';
    };
  }, [mobileMenuOpen]);

  const mobileMenu = (
    <div className="fixed inset-0 bg-white z-50 flex flex-col p-8 pt-24">
      <nav className="flex flex-col space-y-6 text-center">
        <a
          href="#ventures"
          className="font-display text-3xl"
          onClick={() => setMobileMenuOpen(false)}
        >
          Ventures
        </a>
        <a
          href="#about"
          className="font-display text-3xl"
          onClick={() => setMobileMenuOpen(false)}
        >
          About
        </a>
        <a
          href="#contact"
          className="font-display text-3xl"
          onClick={() => setMobileMenuOpen(false)}
        >
          Contact
        </a>
      </nav>
    </div>
  );

  return (
    <div className="font-sans bg-white text-ink min-h-screen antialiased">
      {/* Header */}
      <Header isHomePage={true} externalScrollY={scrollY} />
      {mobileMenuOpen && menuPortalRoot && createPortal(mobileMenu, menuPortalRoot)}
      <main>
        <HeroSection
          title={{ line1: "We build", line2: "what should", line3: "exist." }}
          description="TND Labs is an independent venture studio founded by David and Tamara McKinney. We turn ideas into products, brands, technology, and businesses."
          primaryButtonText="Explore our ventures"
          secondaryButtonText="Talk to us"
          primaryButtonLink="#ventures"
          secondaryButtonLink="#contact"
        />

        <VenturesSection
          sectionVariants={sectionVariants}
          itemVariants={itemVariants}
        />

        <PersonalTouchSection
          sectionVariants={sectionVariants}
          itemVariants={itemVariants}
        />

        <AboutSection
          sectionVariants={sectionVariants}
          itemVariants={itemVariants}
        />

        <FoundersSection
          sectionVariants={sectionVariants}
          itemVariants={itemVariants}
        />

        <ContactSection
          sectionVariants={sectionVariants}
          itemVariants={itemVariants}
        />
      </main>
      <Footer />
    </div>
  );
}

export default App;
